@if (authLoading | async) {
  <app-loading></app-loading>
}
